// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1ZBUP","bigColWidth":"Table_bigColWidth__1IMAk","biggerColWidth":"Table_biggerColWidth__1YHki","row":"Table_row__1wIUC","col":"Table_col__2O5xg"};